import { ApiSchoolsService } from 'src/app/service/api-schools.service';
import { Component, OnInit, EventEmitter, Output, HostListener, ViewChild, ElementRef, Renderer2, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms'; // AbstractControl,  ValidationErrors, ValidatorFn, Validators
import { HttpHeaders } from '@angular/common/http';
import { School } from 'src/app/model/school.model';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
    selector: 'app-search-by-layer',
    templateUrl: './search-by-layer.component.html',
    styleUrls: ['./search-by-layer.component.css']
})
export class SearchByComponent implements OnInit {
    @Output() onSearchParmEvent: EventEmitter<any> = new EventEmitter();
    @Output() onResetEvent: EventEmitter<any> = new EventEmitter();

    @ViewChild('cds1') nextField1!: ElementRef;
    @ViewChild('cds2') nextField2!: ElementRef;
    @ViewChild('cds3') nextField3!: ElementRef;
    @ViewChild('cityfromcds') nextField4!: ElementRef;
    dataValues: any = [];
    dataKeys: Array<any> = [];
    longText = ``;
    schools!: any;
    school = new School();
    searchSchoolsForm!: UntypedFormGroup;
    public myError: string = '';
    toppings = new UntypedFormControl();
    isLoadingResults = true;
    pasteCount: number = 0;
    pastedText: string = '';
    schoolName: string = '';
    schoolNameTest: string = '';
    public cdsCode1Val: number;

    constructor(private service: ApiSchoolsService, private fb: UntypedFormBuilder, public renderer: Renderer2, private utilityService: UtilityService) {}

    ngOnInit(): void {
        this.searchSchoolsForm = new UntypedFormGroup({
            cdsCode1: new UntypedFormControl(null),
            cdsCode2: new UntypedFormControl(null),
            cdsCode3: new UntypedFormControl(null),
            city: new UntypedFormControl(null),
            schoolName: new UntypedFormControl(null), //  [Validators.required], this.forbiddenNameValidator(/chris/i)could also be null - 'Default user name'
            schoolAddress: new UntypedFormControl(null), // , [Validators.required]
            txtErrorMsg: new UntypedFormControl(null)
        });

        let params = new HttpHeaders();

        const timeSpinnerOut = setTimeout(() => {
            this.isLoadingResults = false;
            //console.log("searchby setting isLoadingResults to false")
        }, 7000);
    }

    ngAfterViewInit(): void {
        if (this.nextField1 != null || this.nextField2 != null || this.nextField3 != null) {
            this.renderer.listen(this.nextField1.nativeElement, 'paste', (event) => {
                this.setCDSFieldValue(1, event);
            });

            this.renderer.listen(this.nextField2.nativeElement, 'paste', (event) => {
                this.setCDSFieldValue(2, event);
            });

            this.renderer.listen(this.nextField3.nativeElement, 'paste', (event) => {
                this.setCDSFieldValue(3, event);
            });
        }
    }

    setCDSFieldValue(fieldNumber: number, event: any) {
        try {
            this.pasteCount++;
            this.pastedText = event.clipboardData?.getData('text') || '';

            if (fieldNumber == 1) {
                let curVal: string = this.searchSchoolsForm.controls['cdsCode1'].value || '';
                let iCurLen: number = curVal?.length || 0;
                this.searchSchoolsForm.controls['cdsCode1'].setValue(curVal.concat(this.pastedText.substring(iCurLen, 2 - iCurLen)));
            }
            if (this.pastedText.length > 2) {
                if (fieldNumber == 2) {
                    let curVal: string = this.searchSchoolsForm.controls['cdsCode2'].value || '';
                    let iCurLen: number = curVal.length;
                    this.searchSchoolsForm.controls['cdsCode2'].setValue(curVal.concat(this.pastedText.substring(0, 5 - iCurLen)));
                } else if (fieldNumber == 3) {
                    let curVal: string = this.searchSchoolsForm.controls['cdsCode3'].value || '';
                    let iCurLen: number = curVal.length;
                    this.searchSchoolsForm.controls['cdsCode3'].setValue(curVal.concat(this.pastedText.substring(iCurLen)));
                }
            }
        } catch (Err) {
            console.log('paste event error:' + Err);
        }
    }

    @HostListener('window:keyup', ['$event'])
    cdsKeyDown(event: KeyboardEvent) {
        const keyCode = event.key;
        //const pattern = /[0-9\+\-\ ]/;
        // (keyCode == "Control") || (keyCode == "V") || (keyCode == "v") || (keyCode == "Tab") || (keyCode == "ArrowRight") || (keyCode == "ArrowLeft") || (keyCode == "Backspace") || (keyCode == "Delete")
        if (keyCode == ' ' || this.utilityService.isValidKeys(event) || (keyCode >= '0' && keyCode <= '9')) {
            if (keyCode == 'Backspace') {
                const myField = event.target as HTMLInputElement;
                if (myField.value.length == 0) {
                    switch (myField.id) {
                        case 'cdsCode3':
                            this.nextField2.nativeElement.focus();
                            break;
                        case 'cdsCode2':
                            this.nextField1.nativeElement.focus();
                            break;
                    }
                }
            }
        } else {
            event.preventDefault();
        }
    }

    onKeyDown(e: any) {
        const pattern = /[A-Za-z\+\-\ ]/; // /[0-9\+\-\ ]/;
        if (e.key) {
            // console.log(e.key)
            let inputChar = e?.key?.toString();

            // reset errors here
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed, onKeyDown');
                e.preventDefault();
            } else {
                if (e.srcElement.id == 'schoolName') {
                    this.fnCheckSchoolName(e, '');
                }
            }
        }
    }

    fnCheckSchoolName(e: any, inputChar: any, pastedText?: string) {
        console.log('fnCheckSchoolName');
        console.log(inputChar);
        console.log(pastedText);
        let incLen: number = 1;
        let bIsBackSpace: boolean = false;

        if (e.key == 'Backspace') {
            bIsBackSpace = true;
            incLen = -1;
        }
        var testLen = this.schoolName?.length + incLen;
        if (pastedText) {
            console.log('pasted text:');
            console.log(pastedText);
            testLen = pastedText?.length;
            this.schoolName = '0';
            this.schoolName = pastedText;
        }
        if (!testLen || testLen == 100 || (bIsBackSpace && testLen == 101)) {
            console.log('calling checkSchoolNameOnKey');
            //this.checkSchoolNCESOnKey(this.txtSchoolNcesFC, inputChar);
        } else if (testLen > 100) {
            if (!this.utilityService.isValidKeys(e)) {
                e.preventDefault();
            }
        }
    }

    onKeyUp(e: any) {
        if (e.srcElement.maxLength === e.srcElement.value.length) {
            e.preventDefault();

            let nextControl: any = e.srcElement.nextElementSibling;
            while (true) {
                if (nextControl) {
                    switch (e.srcElement.id) {
                        case 'cdsCode1':
                            this.nextField2.nativeElement.focus();
                            break;
                        case 'cdsCode2':
                            this.nextField3.nativeElement.focus();
                            break;
                        case 'cdsCode3':
                            this.nextField4.nativeElement.focus();
                            break;
                    }

                    if (nextControl.type == 'tel') {
                        nextControl.focus();
                        return;
                    } else {
                        nextControl = nextControl.nextElementSibling;
                    }
                } else {
                    return;
                }
            }
        }
    }

    fnSearch() {
        /* console.log("search by calling fnSearch with:");
     console.log(this.searchSchoolsForm.controls['schoolName'].value
       + " " + this.searchSchoolsForm.controls['schoolAddress'].value
       + " " + this.searchSchoolsForm.controls['cdsCode1'].value
       + " " + this.searchSchoolsForm.controls['cdsCode2'].value
       + " " + this.searchSchoolsForm.controls['cdsCode3'].value
       + " " + this.searchSchoolsForm.controls['city'].value);
    */

        var inSchoolName = this.searchSchoolsForm.controls['schoolName'].value;
        var inSchoolAddress = this.searchSchoolsForm.controls['schoolAddress'].value;
        var inCdsCode1 = this.searchSchoolsForm.controls['cdsCode1'].value;
        var inCdsCode2 = this.searchSchoolsForm.controls['cdsCode2'].value;
        var inCdsCode3 = this.searchSchoolsForm.controls['cdsCode3'].value;
        var inCity = this.searchSchoolsForm.controls['city'].value;

        if (inSchoolName) inSchoolName = inSchoolName.trim();
        if (inSchoolAddress) inSchoolAddress = inSchoolAddress.trim();
        if (inCdsCode1) inCdsCode1 = inCdsCode1.trim();
        if (inCdsCode2) inCdsCode2 = inCdsCode2.trim();
        if (inCdsCode3) inCdsCode3 = inCdsCode3.trim();
        if (inCity) inCity = inCity.trim();
/*
         console.log("search by calling fnSearch with:" + inSchoolName + "."
      + " " + inSchoolAddress
      + " " + inCdsCode1
      + " " + inCdsCode2
      + " " + inCdsCode3
      + " " + inCity);*/
   

        var myJson = {
            schoolName: '',
            schoolAddress: '',
            CDSCode1: '',
            CDSCode2: '',
            CDSCode3: '',
            schoolCity: '',
            chosenCounties: [],
            chosenSchoolDistricts: [],
            chosenRegions: []
        };

        if (inSchoolName != null) {
            myJson.schoolName = inSchoolName;
        }
        if (inSchoolAddress != null) {
            myJson.schoolAddress = inSchoolAddress;
        }
        if (inCdsCode1 != null) {
            myJson.CDSCode1 = inCdsCode1;
        }
        if (inCdsCode2 != null) {
            myJson.CDSCode2 = inCdsCode2;
        }
        if (inCdsCode3 != null) {
            myJson.CDSCode3 = inCdsCode3;
        }
        if (inCity != null) {
            myJson.schoolCity = inCity;
        }
        this.myError = '';
        this.onSearchParmEvent.emit(myJson);
    }

    catchSearchError(err: any) {
        console.log('search by caught error:' + err);
        this.myError = 'No school results. Please check your input. Error during search:' + err;
    }

    fnReset() {
        this.searchSchoolsForm.controls['cdsCode1'].reset();
        this.searchSchoolsForm.controls['cdsCode2'].reset();
        this.searchSchoolsForm.controls['cdsCode3'].reset();
        this.searchSchoolsForm.controls['city'].reset();
        this.searchSchoolsForm.controls['schoolName'].reset();
        this.searchSchoolsForm.controls['schoolAddress'].reset();
        this.searchSchoolsForm.controls['txtErrorMsg'].reset();
        var myJson = {};
        this.myError = '';

        this.onResetEvent.emit(myJson);
    }
}
